// extracted by mini-css-extract-plugin
module.exports = {"transcriptToggle":"styles-module__transcriptToggle___341OX","transcriptToggleButtons":"styles-module__transcriptToggleButtons___2Mb2t","active":"styles-module__active___2Aa4S"};